module.exports = __webpack_public_path__ + "img/image4.b6488f29.png";